import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Container, Form, Modal, Table } from "react-bootstrap";
import { deleteItemCart, extendCartSession } from "../actions/cartActions";
import { RootState } from "../reducers";
import ProductTagsTypes from "./ProductTagsTypes";
import { PencilSquare, TrashFill } from "react-bootstrap-icons";
import Loading from "./Loading";
import { Cart } from "../actions/types";
import parse from "html-react-parser";
import { useNavigate } from "react-router-dom";

const CartList = () => {
  const cart = useSelector((state: RootState) => state.cart.cart);
  const totalCart = useSelector((state: RootState) => state.cart.totalCart);
  const itemsCart = useSelector((state: RootState) => state.cart.itemsCart);
  const minimumCart = useSelector((state: RootState) => state.cart.minimumCart);
  const textPages = useSelector((state: RootState) => state.shop.textPages);
  const isLoading = useSelector((state: RootState) => state.cart.isLoading);
  const frequentUserCoupon = useSelector(
    (state: RootState) => state.cart.frequentUserCoupon
  );
  const navigate: any = useNavigate()
  const [coupon, setCoupon] = useState("");
  const [isFrequentUser, setIsFrequentUser] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    dispatch(extendCartSession())
    setShow(true);
  };

  const dispatch: any = useDispatch()

  useEffect(() => {
    if (coupon === frequentUserCoupon) {
      setIsFrequentUser(true);
    } else {
      setIsFrequentUser(false);
    }
  }, [coupon, frequentUserCoupon]);

  const onDeleteItemCart = (id: string) => {
    dispatch(deleteItemCart(id));
  };

  return (
    <Container>
      {!isFrequentUser && minimumCart > itemsCart && (
        <h4 className="text-center">
          El mínimo de compra son {minimumCart} productos.
        </h4>
      )}

      {isLoading && <Loading />}

      {!isLoading && itemsCart > 0 && (
        <div>
          <Table bordered className="text-center align-middle">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Precio</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <>
                {(cart as Cart[]).map((item: Cart, index: number) => <tr key={index}>
                  <td>
                    <p>
                      <img
                        alt={item.name}
                        className="rounded"
                        src={item.options.img}
                        height="100"
                        onClick={() => navigate("/product/" + item.id)}
                      />
                    </p>
                    {item.name}{" "}
                    <ProductTagsTypes types={item.options.product.types} />
                  </td>
                  <td>
                    <Button
                      className="btn-light mb-2"
                      onClick={() => navigate("/product/" + item.id)}
                    >
                      <b>{item.qty}</b>
                      <PencilSquare className="ms-2" />
                    </Button>
                    <Button
                      className="btn-light mb-2"
                      onClick={() => navigate("/product/" + item.id)}
                    >
                      ${item.price} c/u
                    </Button>
                  </td>
                  <td>
                    <Button className="btn-light mb-2">
                      ${item.qty * item.price}
                    </Button>
                    <Button
                      className="btn-danger mb-2"
                      onClick={() => onDeleteItemCart(item.rowId)}
                    >
                      <TrashFill />
                    </Button>
                  </td>
                </tr>)}
                <tr>
                  <td colSpan={2} className="text-end">
                    <h5>Total:</h5>
                  </td>
                  <td>
                    <h5>{totalCart}</h5>
                  </td>
                </tr>
              </>
            </tbody>
          </Table>
          <div className="col-md-3 float-end text-end mb-4">
            <Form.Group className="mb-2">
              <Form.Control
                name="coupon"
                size="lg"
                placeholder="Código vendedor"
                defaultValue={coupon}
                onChange={(element) => setCoupon(element.target.value)}
              />
            </Form.Group>
            <Button
              variant="secondary btn-lg mb-2"
              onClick={() => navigate("/")}
            >
              Agregar más productos
            </Button>
            {(isFrequentUser || itemsCart >= minimumCart) && (
              <Button variant="success btn-lg ms-1 mb-2" onClick={handleShow}>
                Finalizar compra
              </Button>
            )}
          </div>
        </div>
      )}
      {!isLoading && itemsCart === 0 && (
        <div className="text-center">
          <Button
            variant="secondary btn-lg mb-2"
            onClick={() => {
              navigate("/");
            }}
          >
            Inicio
          </Button>
        </div>
      )}
      <Modal show={show} onHide={handleClose} scrollable={true} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Antes de comprar leé ésta información</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {textPages?.termsAndConditions && parse(textPages.termsAndConditions)}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary btn-lg" onClick={handleClose}>
            Volver
          </Button>
          <Button
            variant="success btn-lg"
            onClick={() => navigate("/checkout")}
          >
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};
export default CartList;
